
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","data-name":"사각형 1194","fill":"none"}}),_c('path',{attrs:{"d":"M20.4 5L19 3.6l-7 7-7-7L3.6 5l7 7-7 7L5 20.4l7-7 7 7 1.4-1.4-7-7z","data-name":"패스 1199"}})])
          )
        }
      }
    